import React, {useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function Sponsors({ data }) {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [sliderSettings, setSliderSettings] = useState({});

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener when the component unmounts
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        let settings = {
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            arrows: false,
        };
        if (screenWidth < 480) {
            settings.slidesToShow = 1;
        } else if (screenWidth < 767) {
            settings.slidesToShow = 3;
        }
        setSliderSettings(settings);
    }, [screenWidth]);

    return (
        <div key={data.documentId} className="sponsors">
            <div className="views-row views-row-5 views-row-odd">


                {/*<article id="node-6" className="node node-sponsors-band node-promoted node-teaser contextual-links-region clearfix" about="/node/6" typeof="sioc:Item foaf:Document">*/}

                    <div className="row background-full-width light-gray-background screen-width">

                        <div className="max-width" style={{ margin: "0 auto" }}>
                            <h4 className="light-blue-text section-headline sponsors-title">
                                { data.titleText }
                            </h4>
                        </div>

                        <Slider {...sliderSettings} className="sponsors-div row autoplay-sponsors" style={{ margin: "0 auto", maxWidth: "1320px" }}>
                            {data.sponsorLogos.map((sponsorLogo, sponsorLogoIdx) => (
                                <div key={ sponsorLogoIdx } className="col-md-2 col-xs-6 sponsor-logo">
                                    <a href={ sponsorLogo.link.url } target="_blank">
                                        <img id={ sponsorLogo.logo.alternativeText.replaceAll(" ", "") } className="logos img-fluid" src={ sponsorLogo.logo.url } alt={ sponsorLogo.logo.alternativeText }/>
                                    </a>
                                </div>
                            ))}
                        </Slider>

                    </div>

                {/*</article>*/}

            </div>
        </div>
    );
}

export default Sponsors;
